import React, { useEffect, useState } from 'react';
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    makeStyles,
    Typography,
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import { IIndexable } from '../GraphicsLibrary/GraphicDetail/GraphicDetail';
import { useTypedSelector } from '../../shared/hooks/useTypedSelector';
import { useTranslation } from 'react-i18next';
interface Props {
    isOpen: boolean;
    onClose: () => void;
    onSave: (name: string, saveAsNew: boolean) => void;
    getDesignNameFceName: string;
    propSaveAsNew: boolean;
}

const useStyles = makeStyles((theme) => ({
    dialog: {
        padding: '20px',
    },
    button: {
        height: '3rem',
    },
    textInput: {
        height: '3rem',
        lineHeight: '3rem',
    },
}));

const SaveDesignDialog: React.FC<Props> = (props) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const { isOpen, onClose, onSave, getDesignNameFceName } = props;

    const [name, setName] = useState('');

    const { loading } = useTypedSelector(
        (state) => state.saveDesign.saveDesign
    );

    useEffect(() => {
        setName((window as IIndexable)[getDesignNameFceName]());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setName(event.target.value);
    };

    const handleSave = () => {
        onSave(name, true);
    };

    return (
        <Dialog open={isOpen} maxWidth={'md'} onClose={onClose}>
            <DialogTitle>
                <Typography variant="body1">{t('Save your design')}</Typography>
            </DialogTitle>
            <DialogContent className={classes.dialog}>
                <TextField
                    placeholder="Name"
                    value={name}
                    variant="outlined"
                    autoFocus={true}
                    onChange={handleNameChange}
                    InputProps={{
                        className: classes.textInput,
                    }}
                    onKeyPress={(event) => {
                        if (event.key === 'Enter' && name.length > 0) {
                            handleSave();
                        }
                    }}
                />
                <Button
                    onClick={handleSave}
                    color="primary"
                    variant="outlined"
                    className={classes.button}
                    type="submit"
                    disabled={name.length === 0}
                >
                    {!loading && <>{t('Save')}</>}
                    {loading && <CircularProgress size="1.5rem" />}
                </Button>
            </DialogContent>
        </Dialog>
    );
};

export default SaveDesignDialog;
